module.exports = __webpack_public_path__ + "static/media/i-cursor.9e966312.svg";